import { type UseMutationOptions, useMutation } from '@tanstack/react-query';

import type { Maybe } from '../../resources/@types/accountSchema';
import { type RequestOptions, antmanFetcher } from '../../resources/Fetcher';
import type { ClientRefererObject } from '../utils/refererObject';

export type V1UserCollectInfoVariables = ClientRefererObject;

export interface V1UserCollectInfoResponse {
  data: Maybe<object>;
}

export function useV1UserCollectCreateMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<
    V1UserCollectInfoResponse,
    unknown,
    V1UserCollectInfoVariables,
    TContext
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<
    V1UserCollectInfoResponse,
    unknown,
    V1UserCollectInfoVariables,
    TContext
  >((variables) => antmanFetcher.post(url, variables, requestOptions), options);

  return { ...result, data: result.data?.data };
}

const API_END_POINT = '/v1/user/collect-info';

/**
 * @see {@link https://github.com/inflearn/ant-man-account/blob/66c75e423df15078c687b6392e852a47e6494f8e/inflearn/layout/base/lib/postUserAccessReferer.js#L11}
 * @description user agent 정보 전달
 */
export function useUserCollectInfoCreateMutation(
  options?: Parameters<typeof useV1UserCollectCreateMutation>[0]['options'],
) {
  return useV1UserCollectCreateMutation({
    url: API_END_POINT,
    options,
  });
}
